<template>
    <div :class="{ 'limits-list--selectable': selectable }">
        <template v-if="selectable">
            <RadioBoxes
                :small="!large"
                shadow
                name="limit"
                :model-value="modelValue"
                @update:model-value="applyModelValue($event)"
            >
                <LimitsListCard
                    v-for="limit in limits"
                    :key="limit.id"
                    :selectable="selectable"
                    :limit="limit"
                >
                    <template #limit-append :limit="limit">
                        <slot name="limit-append" :limit="limit"></slot>
                    </template>
                </LimitsListCard>
            </RadioBoxes>
        </template>
        <template v-else>
            <ul
                class="limits-list"
                :class="{
                    'limits-list--centered': limits.length > 2,
                    'limits-list--large': large
                }"
            >
                <LimitsListCard
                    v-for="limit in limits"
                    :key="limit.id"
                    :selectable="selectable"
                    :limit="limit"
                    :active="limitHasSpeaker(limit)"
                >
                    <template #limit-append :limit="limit">
                        <slot name="limit-append" :limit="limit"></slot>
                    </template>
                </LimitsListCard>
            </ul>
        </template>
    </div>
</template>

<script>
import LimitsListCard from './LimitsListCard';
import { RadioBoxes } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'LimitsList',
    components: {
        LimitsListCard,
        RadioBoxes
    },
    props: {
        modelValue: {
            type: [String, Number],
            default: undefined
        },
        modelModifiers: {
            default: () => ({})
        },
        limits: {
            type: Array,
            required: true
        },
        speaker: {
            type: Number,
            default: undefined
        },
        selectable: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],

    methods: {
        limitHasSpeaker(limit) {
            if (!this.speaker) return false;

            return limit.speakers.findIndex(s => s.id === this.speaker) > -1;
        },
        applyModelValue(newValue) {
            if (this.modelModifiers.number) {
                newValue = Number(newValue);
            }

            this.$emit('update:modelValue', newValue);
        }
    }
};
</script>

<style lang="scss" src="./LimitsList.scss"></style>
